import { render, staticRenderFns } from "./AnnouncementTypeForm.vue?vue&type=template&id=04b31e49&scoped=true"
import script from "./AnnouncementTypeForm.vue?vue&type=script&lang=js"
export * from "./AnnouncementTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b31e49",
  null
  
)

export default component.exports